import { Routes, Route, useLocation } from 'react-router';
import { HashRouter } from 'react-router';
import { AnimatePresence } from 'motion/react';
import routes from './routes';
import { IntroPage } from '../intro/ui/IntroPage';
import { WizardPage } from '../wizard/ui/WizardPage';
import { ResultsPage } from '../results/ui/ResultsPage';

export function Router() {

  // At the moment, we use HashRouter
  // - replace by MemoryRouter to disable URL hashes
  // - swith to BrowserRouter for use outside Drupal

  return (
    <HashRouter>
      <AnimatedRoutes />
    </HashRouter>
  );
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path={ routes.wizard } element={ <WizardPage /> } />
        <Route path={ routes.results } element={ <ResultsPage /> } />
        <Route path={ '*' } element={ <IntroPage /> } />
      </Routes>
    </AnimatePresence>
  );
}
